/**
 * The site's two conversion destinations.
 *
 * The funnel has one entry point — the free personalized video review — and
 * every CTA across the site points at it. Contact-style links (the footer's
 * "Contact Us") are the separate "talk to a human" route and stay on the
 * strategist form.
 *
 * They resolve to different pages: the video review has its own intake page
 * with its own table and fulfillment queue, while contact links stay on the
 * strategist form. Changing either here moves every CTA that uses it — that's
 * the whole reason these live in one module rather than as a constant per file.
 */

/** The free video review intake page — the single entry point to the funnel. */
export const VIDEO_REVIEW_URL = "/free-video-review";

/** The strategist inquiry form — general contact, not funnel entry. */
export const STRATEGIST_URL = "/talk-to-a-strategist";
